import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { SharedService } from "../../../shared/services/shared.service";
import { TokenService } from "../../tokenManagement/token.service";

@Injectable()
export class BusinessGuard implements CanActivate {
  perms = this.shared.permissions;
  userLocalDetails: any;

  constructor(
    private shared: SharedService,
    private router: Router,
    private token: TokenService
  ) {
    this.shared.activatePermmisions();
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let isPermitted: boolean = false;

    if (this.perms.UPDATE_CLIENT_ACCOUNTS) {
      isPermitted = true;
    } else {
      this.router.navigate(["/auth"]);
      // location.reload();
      // this.token.clearStorage();
      return isPermitted;
    }
    return isPermitted;
  }
}
